export const CAPTCHA_QUERY_PARAM = 'cloudflare_challenge_spa';
export const RESUBMIT_QUERY_PARAM = 'resubmit-id';
